<template>
  <nav class="emd-menu menu">
    <div class="overflow-auto px-2">
      <template v-for="item in menu">
        <app-menu-item
          v-if="item.showSection"
          :key="item.key"
          :item="item"
          :routeName="routeName"
        >
          <app-menu-subitems
            v-if="item.items"
            :subitems="item.items"
          />
        </app-menu-item>
      </template>
    </div>
    <app-menu-footer
      :accountId="accountId"
      :merchantId="merchantId"
    />
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

import SIDEBAR from './sidebar-items.enum'

export default {
  name: 'AppMenu',
  components: {
    AppMenuItem: () => import('./AppMenuItem.vue'),
    AppMenuSubitems: () => import('./AppMenuSubitems.vue'),
    AppMenuFooter: () => import('./AppMenuFooter.vue')
  },
  data () {
    return {
      isOpenned: false
    }
  },
  computed: {
    ...mapGetters([
      'isCheckoutV2Enabled',
      'permissionIsEnabled',
      'componentIsEnabled',
      'merchantId',
      'accountId',
      'businessModel'
    ]),

    routeName () {
      return this.$route.name
    },

    menu () {
      return SIDEBAR({
        getters: this.$store.getters,
        routeName: this.routeName,
        permissionIsEnabled: this.permissionIsEnabled,
        componentIsEnabled: this.componentIsEnabled,
        businessModel: this.businessModel,
        isCheckoutV2Enabled: this.isCheckoutV2Enabled
      })
    }
  },

  methods: {
    shopTrack () {
      this.$gtag.event('click', {
        event_category: 'shopClick',
        event_label: 'Link shop menu lateral'
      })
    }
  }
}
</script>

<style scoped>
.menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

@media only screen and (max-width: 768px) {
  .menu {
    background-color: var(--color-white);
  }

  .menu:after {
    content: none;
  }
}
</style>
